import React from "react";
import { Container } from "reactstrap";
import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
import ManagerDashboard from "../../components/admin/detailing/manager/ManagerDashboard";

const DetailingManagerDashboard = () => {
  return (
    <Container fluid className="mb-4">
      <Header className="mb-3">
        <HeaderTitle className="d-flex justify-content-between align-items-center w-100">
          <span className="text-dark">Detailing Manager Dashboard</span>
        </HeaderTitle>
      </Header>
      <ManagerDashboard />
    </Container>
  );
};

export default DetailingManagerDashboard;
